import { render, staticRenderFns } from "./wxAddress.vue?vue&type=template&id=20889822&scoped=true&"
import script from "./wxAddress.vue?vue&type=script&lang=js&"
export * from "./wxAddress.vue?vue&type=script&lang=js&"
import style0 from "./wxAddress.vue?vue&type=style&index=0&id=20889822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20889822",
  null
  
)

export default component.exports